import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "stat-group" }
const _hoisted_2 = {
  key: 0,
  class: "stat-group__title"
}
const _hoisted_3 = { class: "stat-group__cell-body" }
const _hoisted_4 = { class: "stat-group__label" }
const _hoisted_5 = {
  key: 1,
  class: "stat-group__value"
}
const _hoisted_6 = {
  key: 0,
  class: "stat-group__icon-wrap",
  "aria-hidden": "true"
}

import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import type { StatItem } from '@/types/StatGroup.types';
import Skeleton from 'primevue/skeleton';

interface Props {
    title?: string
    items: StatItem[]
    columns?: number
    loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatGroup',
  props: {
    title: { default: '' },
    items: {},
    columns: { default: 2 },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const rows = computed(() => {
    const result: StatItem[][] = [];
    for (let i = 0; i < props.items.length; i += props.columns) {
        result.push(props.items.slice(i, i + props.columns));
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "stat-group__grid",
      style: _normalizeStyle({ '--stat-columns': __props.columns })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rowIndex,
          class: _normalizeClass(["stat-group__row", { 'stat-group__row--divided': rowIndex > 0 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, colIndex) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(item.to ? _unref(RouterLink) : 'div'), {
              key: item.id,
              class: _normalizeClass(["stat-group__cell", { 'stat-group__cell--divided': colIndex > 0, 'stat-group__cell--clickable': !!item.to }]),
              to: item.to ?? undefined
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
                  (__props.loading)
                    ? (_openBlock(), _createBlock(_unref(Skeleton), {
                        key: 0,
                        width: "40%",
                        height: "36px",
                        "border-radius": "6px"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.value), 1))
                ]),
                (_ctx.$slots.icon || item.icon || item.iconComponent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _renderSlot(_ctx.$slots, "icon", { item: item }, () => [
                        (item.iconComponent)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.iconComponent), {
                              key: 0,
                              class: "stat-group__icon"
                            }))
                          : (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              class: _normalizeClass([item.icon, "stat-group__icon"])
                            }, null, 2))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          }), 128))
        ], 2))
      }), 128))
    ], 4)
  ]))
}
}

})